import { Component } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { HistoryItem, RouteHistoryService } from '@m4u-angular/core/framework/route-history.service';
import { Subscription } from 'rxjs';

class State extends BaseState {
    History: HistoryItem[];
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent extends BaseComponent<State> {

    private _subscriptions: Subscription[] = [];

    constructor(A: ServiceBagService,
        private routeHistoryService: RouteHistoryService) {
        super(A, 'BreadcrumbComponent', State);
    }

    protected override OnInitComponent(): void {
        this._subscriptions.push(this.routeHistoryService.HistoryItems$.subscribe(history => {
            this.State.History = [ ...history];
        }));
        this.A.SysEvents.SetBreadCrumbVisible(true);
    }

    OnItemClick(item: HistoryItem) {
        this.routeHistoryService.NavigateHistoryItem(item);
    }

    OnBack() {
        this.routeHistoryService.GoBack();
    }

    protected override OnDestroyComponent(): void {
        this._subscriptions.forEach(x => x.unsubscribe());
    }

}
